import {Component, OnDestroy, OnInit} from '@angular/core';

import {Subscription} from 'rxjs';

import {AuthService} from '@shared/authentication/auth.service';
import {getSiteInfo, SiteInfo} from "@shared/helpers/site-info";
import {ShiftContextService} from "../../services/shift-context.service";
import {PowerBiService} from "@shared/services/power-bi.service";
import {PowerBiReport, PowerBiReportParameters} from "@shared/models/power-bi-report";
import {environment} from "@environment";
import {SiteSubinventory, SubinventoryType} from "@shared/models/subinventory";
import {ShiftStatus, WorkedShift} from "@shared/models/worked-shift";
import {ShiftContext} from "../../models/shift-context";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

    canSeePieceRate: boolean = false;
    shiftClosed: boolean = false;
    siteInfo: SiteInfo;
    pimsReport: PowerBiReport | null = null;
    towerReport: PowerBiReport | null = null;
    materialsReport: PowerBiReport | null = null;
    pecoReport: PowerBiReport | null = null;
    palletSubinventories: SiteSubinventory[];
    materialsSubinventories: SiteSubinventory[];
    pecoSubinventories: SiteSubinventory[];
    context: ShiftContext;
    workedShift: WorkedShift;

    params: PowerBiReportParameters[];
    private subscriptions: Subscription[] = [];

    constructor(private authService: AuthService,
                private shiftContextService: ShiftContextService,
                private reportService: PowerBiService) {}

    ngOnInit() {
        this.subscriptions = [
            this.reportService.getReportByName(environment.ids.TowerReportName).subscribe(report => {
                this.towerReport = report;
            }),
            this.reportService.getReportByName(environment.ids.MaterialsReportName).subscribe(report => {
                this.materialsReport = report;
            }),
            this.reportService.getReportByName(environment.ids.PimsReportName).subscribe(report => {
                this.pimsReport = report;
            }),
            this.reportService.getReportByName(environment.ids.PecoReportName).subscribe(report => {
                this.pecoReport = report;
            }),
            this.authService.Roles.subscribe(roles => {
                const prRoles = [ 'scs site admin', 'scs admin', 'it', 'developers' ];

                this.canSeePieceRate = roles.some(role => prRoles.indexOf(role) > -1);
            }),
            this.shiftContextService.WorkedShift.subscribe(ws => this.workedShift = ws),

            this.shiftContextService.CurrentContext.subscribe(context => {
                this.context = context;
                this.palletSubinventories = context?.site.subinventories.filter(s => s.isActive
                      && (s.subinventoryType === SubinventoryType.ChepPlantPallets
                        || s.subinventoryType === SubinventoryType.ChepPalletStorage
                        || s.subinventoryType === SubinventoryType.TpmProduction))
                    .sort((l, r) => l.subinventoryType === r.subinventoryType
                      ? l.name.localeCompare(r.name)
                      : l.subinventoryType - r.subinventoryType)
                this.materialsSubinventories = context?.site.subinventories.filter(s => s.isActive && s.subinventoryType === SubinventoryType.ChepComponents);
                this.pecoSubinventories = context?.site.subinventories.filter(s => s.isActive && s.subinventoryType === SubinventoryType.PecoPallets);
                this.siteInfo = getSiteInfo(context.site);
                this.params = context ? [{rpName: 'siteId', rpValue: context.site.id}] : undefined;
                this.shiftClosed = context?.status !== ShiftStatus.Open;
            })
        ];
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getFileTypes() {
        let fileTypes = ['Inventory Tick', 'Piece Rate', 'Yard Check', 'Audits', 'Driver Logs'];
        if (this.context) {
            if (getSiteInfo(this.context?.site)?.hasPlant) {
                fileTypes = ['Plant End of Shift', ...fileTypes];
            }
            if (getSiteInfo(this.context?.site)?.hasTpm) {
                fileTypes = ['TPM End of Shift', ...fileTypes];
            }
        }
        return fileTypes;
    }
}
